import React from 'react';
import { Col, Row, FormGroup } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { Form, IntBox } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'

class IntBoxDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				preset: 123456789
			}
		};
	}

	handleChange = (form) => {
		this.setState({ form });
	}

	handleSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="IntBox">
				<Form
					values={this.state.form}
					onChange={this.handleChange}
					onSubmit={this.handleSubmit}>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label>Default</Label>
								<IntBox name="default" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label>Placeholder</Label>
								<IntBox name="placeholder" placeholder="Total" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label>Disabled</Label>
								<IntBox name="disabled" disabled={true} />
							</FormGroup>
						</Col >
					</Row >
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label>Preset</Label>
								<IntBox name="preset" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label required>Required</Label>
								<IntBox name="required" required />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label required>Positive Only</Label>
								<IntBox name="positiveNumbersOnly" positiveNumbersOnly required />
							</FormGroup>
						</Col>
					</Row>
					<hr />
					<div className="btn-toolbar">
						<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
					</div>
				</Form >
			</Box >
		)
	}
}

export default IntBoxDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/BasicInputs/IntBoxDemo.js